import { Pin } from 'lucide-react';
import { Chat } from '@/services/chatService';
import { ChatFolder } from '@/services/folderService';
import { DraggableChatItem } from './DraggableChatItem';

interface PinnedChatsSectionProps {
  chats: Chat[];
  plan: string;
  folders: ChatFolder[];
  onEditChat: (chat: Chat) => void;
  onDeleteChat: (chat: Chat) => void;
  onMoveToFolder: (chat: Chat, folderId: string | null) => void;
  onTogglePin: (chat: Chat) => void;
}

export function PinnedChatsSection({
  chats,
  plan,
  folders,
  onEditChat,
  onDeleteChat,
  onMoveToFolder,
  onTogglePin,
}: PinnedChatsSectionProps) {
  const pinnedChats = chats.filter(chat => chat.is_pinned);

  if (pinnedChats.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 px-2 py-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
        <Pin className="h-3 w-3" />
        <span>Fijados ({pinnedChats.length})</span>
      </div>
      <div className="space-y-0.5">
        {pinnedChats.map((chat) => (
          <DraggableChatItem
            key={`pinned-${chat.id}`}
            chat={chat}
            plan={plan}
            folders={folders}
            onEditChat={onEditChat}
            onDeleteChat={onDeleteChat}
            onMoveToFolder={onMoveToFolder}
            onTogglePin={onTogglePin}
          />
        ))}
      </div>
    </div>
  );
}
